import { Injectable } from '@angular/core';
import { Router }    from '@angular/router';
import {HttpClientService} from './http-client.service';
import {AppSettings} from '../app-settings';
import { Observable } from "rxjs";
import { HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';

@Injectable()
export class AdminGuardService {

	userRole:string;
	 constructor(private httpClientService: HttpClientService,private router: Router) { }

	canActivate():Observable<boolean>|boolean
	{
    	let headers = new HttpHeaders();
      return this.httpClientService.get(AppSettings.restApiUrl + 
          '/api/user/roles', headers)
      .pipe(map(
      (data) => {
        var userExpert = data.filter(function(obj){

          return obj.name == "ROLE_EXPERT";
        });
        if(userExpert.length>0)
        {
          this.userRole = 'expert';
          return true;
        }
        else
        {
          this.userRole = 'student';
          this.router.navigate(['/dashboard']);
          return false;
        }
      }
      ));
    	/*if(this.userRole == 'expert')
    	{
   	    	return true;
    	}
   	    else
   	    {
   	    	this.router.navigate(['/dashboard']);
   	    	return false;
   	    }*/
    }

 

  checkAdminLogin()
  {
   
  }

}
